package fr.frux.shared.dto

import kotlinx.serialization.Serializable
import kotlin.time.Instant

/** Version du format de la pyramide : le client refuse tout autre format et garde sa copie. */
const val CLUSTER_PYRAMID_FORMAT_VERSION = 1

/**
 * Pyramide de regroupements précalculée par le serveur (#622, ADR 0039). Les réglages
 * ([radius], [extent], [minPoints]) sont ceux de la source de regroupement du client.
 */
@Serializable
data class ClusterPyramidDto(
    val formatVersion: Int,
    val radius: Int,
    val extent: Int,
    val minPoints: Int,
    val maxZoom: Int,
    val detailZoom: Int,
    @Serializable(with = InstantEpochMillisSerializer::class) val generatedAt: Instant,
    val points: List<ClusterPointDto>,
)

/**
 * Un point d'un niveau [z] : un amas ([n] supérieur à 1, [e] = zoom d'éclatement) ou un arbre isolé
 * ([n] = 1, [treeId] renseigné). [status] et [observedAt] permettent à un point isolé de prendre la
 * même teinte que le lot détaillé. [status] est omis pour un statut inconnu.
 */
@Serializable
data class ClusterPointDto(
    val lat: Double,
    val lon: Double,
    val z: Int,
    val n: Int,
    val e: Int? = null,
    val species: List<SpeciesCountDto>,
    val treeId: Long? = null,
    val needsCheck: Boolean = false,
    val locked: Boolean = false,
    val status: TreeStatusDto? = null,
    @Serializable(with = InstantEpochMillisSerializer::class) val observedAt: Instant? = null,
)

@Serializable
data class SpeciesCountDto(
    val id: Long,
    val n: Int,
)
